import styled from "styled-components"
import Button from "@common/Button/Button"
import { MOBILE_MIN_WIDTH, TABLET_MAX_WIDTH } from "@constants"

export const StyledCallToActionContainer = styled.div`
  width: 100%;
  background: var(--dark-purple);
  padding: 3rem 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    flex-direction: column;
    padding: 2.5rem 2.5rem 3rem;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    padding: 2rem 1.5rem;
    align-items: flex-start;
  }
`

export const StyledDescription = styled.div`
  font-size: 1rem;
  color: var(--main-font-color);
  line-height: 1.625rem;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    margin-bottom: 1.75rem;
  }
  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    margin-bottom: 2rem;
  }
`

export const StyledTitle = styled.div`
  font-size: 1.75rem;
  line-height: 2.5rem;
  font-weight: 700;
  color: #fff;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    margin-bottom: 1rem;
  }
`

export const StyledTextContainer = styled.div`
  width: 60%;
  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    width: auto;
  }
`

export const StyledButtonContainer = styled.a`
  font-size: 1.75rem;
  line-height: 2.5rem;
  font-weight: 700;
  width: 35%;
  text-decoration: none;
  color: inherit;
  word-wrap: break-word;
  white-space: nowrap;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    width: 50%;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    width: 100%;
  }

  img {
    height: 1.1rem !important;
    width: 1.1rem !important;
  }
`

export const StyledCallToActionButton = styled(Button)`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.36px;
`
